import classNames from 'classnames'
import './Chip.scss'

type ChipProps = { children?: React.ReactNode; className?: string; color?: 'red' | 'green' }
export function Chip({ children, className, color }: Readonly<ChipProps>) {
  return <div className={classNames('Chip', className, color)}>{children}</div>
}
